<template>
  <!-- Discreto, depois dos que se veem: diz que há mais, e não quais (decisão do usuário) -->
  <span v-if="count" class="hidden-count text-caption text-medium-emphasis">{{ $tc('hidden-items', count, {count}) }}</span>
</template>

<script lang="ts">
import {Component, Prop, Vue, toNative} from 'vue-facing-decorator'

/**
 * "+N itens ocultos": os relacionados de um item que quem olha não vê. O servidor os tira da resposta —
 * nem o id vem — e manda só quantos eram (`_hidden`); ver o `hiddenCount`, que os lê.
 *
 * Um componente para os quatro lugares que desenham um relacionamento — a ficha, a célula, o card e
 * as seções de relacionados —, para a frase e o tom serem um só.
 */
@Component({name: 'ontos-hidden-count'})
class HiddenCount extends Vue {
  @Prop({type: Number, default: 0}) readonly count!: number
}

export default toNative(HiddenCount)
</script>

<style scoped>
.hidden-count {
  white-space: nowrap;
}
</style>
